import React from 'react'
import { Container } from 'react-bootstrap'
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import { useParams } from 'react-router-dom';
import { Link, useLocation } from 'react-router-dom';
import { TypeAnimation } from 'react-type-animation';
import Footer from '../Footer/Footer';
const Desarrolloweb = () => {

  const location = useLocation();

  // Verificar si la ruta actual es diferente de /Servicios
  const mostrarBoton = location.pathname !== '/Servicios';
  const mostrarSeparador = location.pathname !== '/Servicios';
  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  
const {nombre} = useParams();

  return (
<>
{mostrarSeparador && (
      <div className='separador'>
        <h3 className='colorini titulo-servicio'>
          <TypeAnimation
            sequence={[
              "Servicio: DESARROLLO WEB.",500,
            ]} 
            repeat={0}
            style={{ fontSize: '1.5em' }}
          />
        </h3>
      </div>
    )}

    <Container >
    <div className='div-desarrollo' data-aos="fade-up">
      <h3 className='titulo-servicio' style={ { color:"White",}}>DESARROLLO WEB</h3>{/* titulo */}
      <br></br>
      <h4 className='subtitulo-servicio' style={ { color:"White",}}>¡Destaca tu Negocio con una Página Web Personalizada!</h4>{/* titulo */}
      <br></br>
      <p className="parrafo-servicio" style={ { color:"White",}}>En el competitivo mundo actual, una presencia en línea sólida es esencial para destacar entre la multitud. En NinnoTech, entendemos la importancia de una imagen digital impactante y efectiva. Es por eso que ofrecemos servicios de desarrollo web personalizados, diseñados específicamente para elevar tu empresa o emprendimiento al siguiente nivel, entre ellos:</p>
      <br></br>
  <ul>
 
    
    <li className='listado-servicio' style={ { color:"White",}}> <i class="bi bi-check-circle"></i> Diseño y desarrollo de sitios web personalizados.</li>
    <br></br>
    <li className='listado-servicio' style={ { color:"White",}}> <i class="bi bi-check-circle"></i> Optimización para dispositivos móviles.</li>
    <br></br>
    <li className='listado-servicio' style={ { color:"White",}}> <i class="bi bi-check-circle"></i> Desarrollo de tiendas en línea (E-commerce).</li>
    <br></br>
    <li className='listado-servicio' style={ { color:"White",}}> <i class="bi bi-check-circle"></i> Diseño de Landing Pages.</li>
    
  </ul>
  <br></br>
<p className='parrafo-servicio' style={ { color:"White",}}>¡No dejes que tu presencia en línea pase desapercibida! Eleva tu empresa con una página web personalizada diseñada por NinnoTech. ¡Contáctanos hoy mismo para comenzar tu viaje digital hacia el éxito!</p>


<a href='https://wa.me/2235985787' target='_blank'><Button className='btn-servicios'>Pedir Cotizacion</Button></a>
    
<br></br>
    {mostrarBoton && (
      <Link to="/Servicios">
        <Button className='btn-servicios' style={{ marginLeft:"42.5%"}}  onClick={handleScrollToTop} >Volver a Servicios</Button>
      </Link>
    ) }

        </div>
    </Container>
    {mostrarSeparador && (
      <div className='separador-f'>
      <Footer/>
      </div> 
    )}
    </> 
  )
}

export default Desarrolloweb